const l = "_link_185ab_1", o = "_ellipsis_185ab_46", _ = {
  link: l,
  "color-brand": "_color-brand_185ab_18",
  "color-disabled": "_color-disabled_185ab_26",
  "color-gray": "_color-gray_185ab_35",
  "no-underline": "_no-underline_185ab_43",
  ellipsis: o
};
export {
  _ as default,
  o as ellipsis,
  l as link
};
//# sourceMappingURL=index.es661.js.map
